module.exports = __webpack_public_path__ + "img/facebook.fb00350f.png";